module.exports = __webpack_public_path__ + "img/document-nothing-1.e54fbc59.svg";